/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import { Container, Card } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Radio, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _, { flatMap } from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import Autocomplete from '@mui/material/Autocomplete';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import SearchNotFound from '../../../SearchNotFound';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "CREATECROPFORCAST"

export default function CropForcastListing(props) {

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [route, setRoute] = useState([]);
    const [farmer, setFarmer] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [dateList, setDateList] = useState([]);
    const [cropForcaste, setCropForcaste] = useState([]);
    const [selectedFarmer, setSelectedFarmer] = useState([]);
    const [productVarietyList, setProductVarietyList] = useState([]);
    const [IsUpdate, setIsUpdate] = useState(true);
    const [IsClear, setIsClear] = useState(false);
    const [columName, setColumName] = useState([]);
    const month = ["January", "February", "March", "April", "May",
        "June", "July", "August", "September", "October", "November",
        "December"];
    const d = new Date();
    let name = month[d.getMonth()]
    const navigate = useNavigate();
    const [isFarmerClear, setIsFarmerClear] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        //collectionCenterID: "0",
        farmerID: "0",
        cropCategoryID: "0",
        cropID: "0",
        agentName: '',
        //productVarietyID: "0",
        isActive: true
    });

    const productcatogerySearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center Required'),
        //collectionCenterID: Yup.number(),
        farmerID: isActive == true ? Yup.number().min(1, 'Please Select Farmer').required('Farmer Required') : Yup.number().notRequired(),
        cropCategoryID: isActive == false ? Yup.number().min(1, 'Please Select Crop Category').required('Crop Category Required') : Yup.number().notRequired(),
        cropID: isActive == false ? Yup.number().min(1, 'Please Select Crop').required('Crop Required') : Yup.number().notRequired(),
        //productVarietyID: isActive == false ? Yup.number().min(1, 'Please Select Crop Variety').required('Crop Variety Required') : Yup.number().notRequired(),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            //collectionCenterID: formData.collectionCenterID,
            farmerID: formData.farmerID,
            cropCategoryID: formData.cropCategoryID,
            cropID: formData.cropID,
            givenName: formData.givenName,
            //productVarietyID: formData.productVarietyID,
            isActive: formData.isActive
        },
        validationSchema: productcatogerySearchSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - cropForcaste.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCROPFORCASTADDEDIT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }
    async function SubmitForm(value) {
        setCropForcaste([]);
        const res = await services.GetFarmerCropMappingDetailsByProductIDFarmerID(value.operationEntityID, isActive == true ? value.farmerID : "0", isActive == false ? value.cropID : "0")
        var now = new Date();
        var now1 = now.setDate(now.getDate() + 6);
        var daysOfYear = [];
        for (var d = new Date(); d <= now1; d.setDate(d.getDate() + 1)) {
            daysOfYear.push(new Date(d));
        }
        setDateList(daysOfYear);

        var array = [];
        var array2 = [];
        daysOfYear.forEach(x => {
            const date1 = new Date(x);
            const date2 = x.toISOString().split("T")[0]
            var newformattedDate = date1.getUTCDate();
            array.push(
                { id: newformattedDate }
            )
            array2.push(date2)
        });
        setColumName(array)

        res.forEach(x => {
            x.cropForecasts.forEach(y => {
                y.cropForecastDate = y.cropForecastDate.split("T")[0];
            });
        });

        let newRes = _.cloneDeep(res);
        let newdays = _.cloneDeep(array2);

        newRes.forEach(x => {

            if (x.cropForecasts.length != 0) {
                let box = [];
                x.cropForecasts.forEach(y => {
                    var duplicateDate = newdays.find(z => z === y.cropForecastDate)
                    box.push(duplicateDate)
                });
                newdays.forEach(w => {
                    var duplicateDate = box.find(z => z === w)
                    if (duplicateDate == undefined) {
                        x.cropForecasts.push({
                            cropForecastDetailID: 0,
                            farmerID: x.farmerID,
                            cropID: x.cropID,
                            cropVarietyID: x.cropVarietyID,
                            farmerPlotCropMappingID: x.farmerPlotCropMappingID,
                            cropForecastDate: w,
                            quantity: 0
                        });
                    }
                });
            }
            else {
                newdays.forEach(z => {
                    x.cropForecasts.push({
                        cropForecastDetailID: 0,
                        farmerID: x.farmerID,
                        cropID: x.cropID,
                        cropVarietyID: x.cropVarietyID,
                        farmerPlotCropMappingID: x.farmerPlotCropMappingID,
                        cropForecastDate: z,
                        quantity: 0
                    });
                });
            }
        });
        GenarateCropForcasteTable(newRes)
    }

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetRouteByFactoryID());
        trackPromise(GetFarmerDetailsByFactoryIDRouteID());
        setCropForcaste([]);
        setValues({
            ...values,
            cropCategoryID: "0",
            cropID: "0"
        })
        setIsActive(true);
        setIsFarmerClear(!isFarmerClear);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setValues({
            ...values,
            farmerID: "0"
        })
        setIsClear(!IsClear);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setCropForcaste([]);
        setValues({
            ...values,
            cropCategoryID: "0",
            cropID: "0",
            farmerID: "0",
            givenName: '',
        });
        setIsClear(!IsClear);
        setIsFarmerClear(!isFarmerClear);
    }, [isActive]);

    useEffect(() => {
        trackPromise(GetAllProductVarietyByProductID());
        setCropForcaste([]);
    }, [formik.values.cropID]);

    useEffect(() => {
        setIsFarmerClear(!isFarmerClear);
        setCropForcaste([]);
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setCropForcaste([]);
    }, [formik.values.farmerID]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            setProductcatogery(res);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(formik.values.operationEntityID, formik.values.cropCategoryID)
        if (res != null) {
            setProduct(res);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            setFactory(res);
        }
    }

    async function GetRouteByFactoryID() {
        var res = await services.GetRouteByFactoryID(formik.values.operationEntityID)
        if (res != null) {
            setRoute(res);
        }
    }

    async function GetFarmerDetailsByFactoryIDRouteID() {
        var result = await services.GetFarmerDetailsByFactoryIDRouteID(formik.values.operationEntityID);
        result.forEach(x => {
            x.givenName = x.givenName == null || x.givenName == "" ? x.farmerCode : x.givenName
        })
        setFarmer(result);
    }

    async function GetAllProductVarietyByProductID() {
        var res = await services.GetAllProductVarietyByProductID(formik.values.cropID);
        if (res != null) {
            setProductVarietyList(res);
        }
    }

    const handleRadioChange = (event) => {
        setIsActive(event.target.value);
        setCropForcaste([]);
    };

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }
    async function GenarateCropForcasteTable(data) {
        var result = [];
        data.forEach(x => {
            let GivenName = x.farmerName == null ? "" : x.farmerName
            let Surname = x.surname == null ? "" : x.surname
            let Nic = x.nic == null ? "" : x.nic
            x.cropForecasts.forEach(y => {
                const date1 = new Date(y.cropForecastDate);
                var newformattedDate = date1.getUTCDate();
                var duplicateDate = isActive == true ? result.find(y => y.cropVarietyID === x.cropVarietyID && y.farmerPlotCropMappingID === x.farmerPlotCropMappingID)
                    : result.find(y => y.farmerID === x.farmerID && y.farmerPlotCropMappingID === x.farmerPlotCropMappingID);

                if (duplicateDate) {
                    duplicateDate[newformattedDate] = y.quantity;
                    duplicateDate.farmerName = GivenName + ' ' + Surname + ' - ' + Nic;
                    duplicateDate.productName = x.productName;
                    duplicateDate.farmerID = x.farmerID;
                    duplicateDate.cropID = x.cropID;
                    duplicateDate.cropVarietyID = x.cropVarietyID;
                    duplicateDate.varietyName = x.varietyName;
                    duplicateDate.farmerPlotCropMappingID = x.farmerPlotCropMappingID
                    duplicateDate.plotName = x.plotName
                }
                else {
                    result.push({
                        [newformattedDate]: y.quantity,
                        farmerName: GivenName + ' ' + Surname + ' - ' + Nic,
                        productName: x.productName,
                        plotName: x.plotName,
                        farmerID: x.farmerID,
                        cropID: x.cropID,
                        cropVarietyID: x.cropVarietyID,
                        varietyName: x.varietyName,
                        farmerPlotCropMappingID: x.farmerPlotCropMappingID,
                    });
                }
            });
        });
        let index = 0;
        result.forEach(x => {
            x.rowID = index++;
        });
        setCropForcaste(result)
    }

    function changeText(e, rowID, columnID) {
        setIsUpdate(true)
        const target = e.target;
        const value = target.value;
        const finalValue = value == "" ? parseFloat(0) : value
        var reg = new RegExp('^[0-9]{0,9}([.]?[0-9]{0,2})?$');

        if (reg.test(finalValue) == false) {
            toast.error("Allow Only Numbers");
            return;
        }
        const newArr = [...cropForcaste];
        var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
        newArr[idx] = { ...newArr[idx], [columnID]: finalValue == "" ? parseFloat(0) : parseFloat(finalValue) };
        setCropForcaste(newArr)
    }

    async function handleSave() {
        var result = [];
        cropForcaste.forEach(x => {
            let model = {
                farmerID: x.farmerID,
                cropID: x.cropID,
                cropVarietyID: x.cropVarietyID,
                farmerPlotCropMappingID: x.farmerPlotCropMappingID,
                details: [],
                createdBy: parseInt(TokenDecoder.getUserIDFromToken())
            };
            dateList.forEach(y => {
                const date1 = new Date(y);
                const date2 = y.toISOString().split("T")[0]
                var newformattedDate = date1.getUTCDate();
                // if (x[newformattedDate] != 0) {
                model.details.push({
                    farmerID: x.farmerID,
                    cropID: x.cropID,
                    cropVarietyID: x.cropVarietyID,
                    farmerPlotCropMappingID: x.farmerPlotCropMappingID,
                    cropForecastDate: date2,
                    quantity: x[newformattedDate]
                });
                //}
            });
            result.push(model)
        });
        var res = await services.UpdateCropForcasting(result);
        if (res.statusCode === "Success") {
            toast.success(res.message);
            setIsUpdate(false)
        } else {
            toast.error(res.message);
        }
    }
    function handleSearch(data, e) {

        if (data === undefined || data === null) {
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            var valueV = data["farmerID"];

            setValues({
                ...values,
                farmerID: valueV.toString()
            });
        }
    }

    function handleSearchCrop(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                cropID: 0
            });
            return;
        } else {
            var valueV = data["productID"];

            setValues({
                ...values,
                cropID: valueV
            });
        }
    }

    function clearAll() {
        formik.resetForm()
        // setFormData({
        //     ...formData
        //   });
        setCropForcaste([]);
        setValues({
            ...values,
            cropCategoryID: "0",
            cropID: "0",
            farmerID: "0",
            givenName: '',
        });
        setIsActive(true);
        setIsClear(!IsClear);
        setIsFarmerClear(!isFarmerClear);
        setSelectedFarmer([]);
    }

    function handleSearchDropdownChangePrefferdName(data, e) {
        if (data === undefined || data === null) {            
            setSelectedFarmer(data);
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            setSelectedFarmer(data);
            var nameP = 'farmerID';
            var valueP = data.farmerID;
            setValues({
                ...values,
                farmerID: valueP
            });
        }
    }

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.givenName && option.givenName.toLowerCase().includes(trimmedInput)) ||
            (option.nic && option.nic.toLowerCase().startsWith(trimmedInput)) ||
            (option.farmerCode && option.farmerCode.toLowerCase().startsWith(trimmedInput))
        ).filter(option => option.givenName !== null && option.nic !== null && option.farmerCode !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.givenName.toLowerCase() === trimmedInput ||
                option.nic.toLowerCase() === trimmedInput ||
                option.farmerCode.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });

        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Daily Crop Update |  FAPS">
                <Container maxWidth>
                    <CommonPageHeader
                        path={"/createCropForcast"}
                        btname="Add"
                        pageName="Daily Crop Update"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            {/* <Form autoComplete="off" noValidate onSubmit={handleSubmit}> */}
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Grid item md={4} xs={12} >
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}> Select Group</MenuItem>
                                            {group.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={4} xs={12} >
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Fresh Collection Center *"
                                            value={formik.values.operationEntityID}
                                            onChange={formik.operationEntityID}

                                            {...getFieldProps('operationEntityID')}
                                            error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                            helperText={touched.operationEntityID && errors.operationEntityID}
                                            InputProps={{
                                                readOnly: !permissionList.isFactoryFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}> Select Fresh Collection Center</MenuItem>
                                            {factory.map((option) => (
                                                option.isActive == true && option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                    {option.factoryName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={4} xs={12} >
                                        <FormControlLabel
                                            style={{ width: '190px' }}
                                            control={
                                                <Radio
                                                    color="secondary"
                                                    checked={isActive == 1}
                                                    onChange={handleRadioChange}
                                                    value={1}
                                                    name="radio-button-demo"
                                                    inputProps={{ 'aria-label': 'true' }}
                                                />}
                                            label="Farmer wise"
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            style={{ width: '180px' }}
                                            control={
                                                <Radio
                                                    color="secondary"
                                                    checked={isActive == 0}
                                                    onChange={handleRadioChange}
                                                    value={0}
                                                    name="radio-button-demo"
                                                    inputProps={{ 'aria-label': 'false' }}
                                                />}
                                            label="Crop wise"
                                            labelPlacement="end"
                                        />
                                    </Grid>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>

                                    {isActive == true ?
                                        <>
                                            <Grid item md={4} xs={12}>
                                                <Autocomplete
                                                    fullWidth
                                                    key={isFarmerClear}
                                                    clearOnEscape
                                                    id="farmerID"
                                                    options={farmer}
                                                    filterOptions={filterOptions}
                                                    getOptionLabel={(option) => `${option.givenName} - ${option.nic}`}
                                                    onChange={(e, value) => handleSearchDropdownChangePrefferdName(value, e)}
                                                    renderOption={(props, option) => (
                                                        <li {...props}>
                                                            {`${option.givenName} - ${option.nic}`}
                                                        </li>
                                                    )}
                                                    renderInput={(params) =>
                                                        <TextField {...params}
                                                            variant="outlined"
                                                            name="farmerID"
                                                            label="Farmer Preferred Name / NIC *"
                                                            size="small"
                                                            fullWidth
                                                            helperText={touched.farmerID && errors.farmerID}
                                                            error={Boolean(touched.farmerID && errors.farmerID)}
                                                        />
                                                    }
                                                />
                                            </Grid>

                                            <Grid item md={4} xs={12}>

                                            </Grid>


                                        </>
                                        : null}
                                    {isActive == false ?
                                        <Grid item md={4} xs={12} >
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Crop Category *"
                                                value={formik.values.cropCategoryID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('cropCategoryID')}
                                                error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}
                                                helperText={touched.cropCategoryID && errors.cropCategoryID}
                                            >
                                                <MenuItem key={0} value={0}> Select Crop Category</MenuItem>
                                                {productcatogery.map((option) => (
                                                    option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                                                        {option.productCategoryName}
                                                    </MenuItem> : null
                                                ))}
                                            </TextField>
                                        </Grid>
                                        : null}
                                    {isActive == false ?
                                        <Grid item md={4} xs={12} >
                                            <Autocomplete fullWidth
                                                key={isFarmerClear}
                                                id="cropID"
                                                options={product}
                                                getOptionLabel={(option) => option.productName != null ? option.productName.toString() : null}
                                                onChange={(e, value) => handleSearchCrop(value, e)}
                                                defaultValue={null}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        variant="outlined"
                                                        name="cropID"
                                                        label="Crop *"
                                                        size="small"
                                                        fullWidth
                                                        value={formik.values.cropID}
                                                        getOptionDisabled={true}
                                                        helperText={touched.cropID && errors.cropID}
                                                        error={Boolean(touched.cropID && errors.cropID)}
                                                    />
                                                }
                                            />
                                        </Grid> : null}
                                    <Grid item md={2} xs={12} >
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color='error'
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {cropForcaste.length != 0 ? <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <TableContainer sx={{ maxHeight: 440 }}>
                                <Table size="small" border='1px' stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow sx={{ border: "2px solid black", backgroundColor: "#8593AD", fontWeight: "900" }} >
                                            <TableCell align='center' colSpan={4} sx={{ backgroundColor: "#8593AD", fontWeight: "bold" }} >{name}</TableCell>
                                            {dateList.map((item) => (
                                                <TableCell sx={{ backgroundColor: "#8593AD" }}> {item.toISOString().split("T")[0]}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow sx={{ border: "2px solid black", backgroundColor: "#D1D9E6" }} >
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>{isActive == true ? 'Farmer' : 'Crop'}</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>{isActive == true ? 'Crop' : 'Farmer'}</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Variety</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Plot</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", top: 38, fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ border: "2px solid black" }}>
                                        {cropForcaste.map((row) => (
                                            <TableRow key={row.farmerID}>
                                                <TableCell align='left'>
                                                    {isActive == true ? row.farmerName : row.productName}
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {isActive == true ? row.productName : row.farmerName}
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.varietyName}
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.plotName}
                                                </TableCell>
                                                {columName.map((column) => {
                                                    const value = row[column.id];
                                                    return (
                                                        <TableCell align='center'>
                                                            <Stack width={80} style={{ marginLeft: '10px' }}>
                                                                <TextField
                                                                    size='small'
                                                                    id="outlined-size-small"
                                                                    name={column.id}
                                                                    onChange={(e) => changeText(e, row.rowID, column.id)}
                                                                    value={value}
                                                                    InputProps={{
                                                                        inputProps: {
                                                                            step: 0.01,
                                                                            type: 'number',
                                                                            style: {
                                                                                textAlign: 'right',
                                                                            },
                                                                        },
                                                                    }}
                                                                    onKeyDown={(evt) =>
                                                                        (evt.key === "-") && evt.preventDefault()
                                                                    }
                                                                    onWheel={event => event.target.blur()}
                                                                    textAlign='right'
                                                                />
                                                            </Stack>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                        <br />
                        <Divider variant="middle" /><br />
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color='secondary'
                                onClick={() => trackPromise(handleSave())}
                                disabled={IsUpdate == false}
                            > Update</Button>
                        </Stack>
                        <br />
                    </>
                        : <SearchNotFound searchQuery="Daily Crop Update" />}
                </Container>
            </Page>
        </>
    );
}